import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { Row, Col, Button, Input, Label, FormGroup } from "reactstrap";
import { useHistory, useLocation, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import axios from "axios";
import * as Yup from "yup";
import { Formik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { OffsiteHours_API } from "../OffsiteHours_API";
import "../createOffsiteWorkHours/offsiteHoursRequestForm.scss";
import { UserConsumer } from "../../../UserContext";
import { AlertPopups } from "../../../components/AlertPopups";
import FormStatus from "../../../components/FormStatus";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { Routes } from "../../../configurations/config";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";

function OffsiteHoursRequestForm() {
	let token,
		userName = null;
	const { id } = useParams();
	const history = useHistory();
	const { state } = useLocation();
	const datepickerRef = useRef(null);
	const itemStatus = state ? state.itemStatus : "Draft";
	const DraftStateInitialValues = {
		employeeName: "",
		startTime: {
			hours: "",
			minutes: "",
			time: { value: 0, label: "AM" },
		},
		date: new Date(),
		workType: "",
		workHours: {
			hours: { value: 1, label: "01" },
			minutes: { value: 0, label: "00" },
		},
		empComments: "",
	};
	const initialValues = {
		employeeName: "",
		startTime: {
			hours: " ",
			minutes: "",
			time: { value: 0, label: "AM" },
		},
		date: null,
		workType: "",
		workHours: {
			hours: "",
			minutes: "",
		},
		empComments: "",
	};

	const timeOptions = [
		{ value: 0, label: "AM" },
		{ value: 1, label: "PM" },
	];
	const workHoursOptions = [
		{ value: 1, label: "01" },
		{ value: 2, label: "02" },
		{ value: 3, label: "03" },
		{ value: 4, label: "04" },
		{ value: 5, label: "05" },
		{ value: 6, label: "06" },
		{ value: 7, label: "07" },
		{ value: 8, label: "08" },
		{ value: 9, label: "09" },
		{ value: 10, label: "10" },
		{ value: 11, label: "11" },
		{ value: 12, label: "12" },
	];
	const workMinutesOptions = [
		{ value: 0, label: "00" },
		{ value: 1, label: "15" },
		{ value: 2, label: "30" },
		{ value: 3, label: "45" },
	];
	const workTypeOptions = [
		{ value: 1, label: "Work From Home" },
		{ value: 2, label: "Onfield Work" },
		{ value: 3, label: "Official Training" },
		{ value: 4, label: "Official Travelling" },
		{ value: 5, label: "Customer Onsite" },
		{ value: 6, label: "Work From Office On Offday" },
		{
			value: 7,
			label: "Work From Office on Offday from Attendance System",
		},
	];

	const [offsiteRequestFormFields, setOffsiteRequestFormFields] = useState(
		itemStatus === "Draft" ? DraftStateInitialValues : initialValues
	);
	const [workTypes, setWorkTypes] = useState(null);
	const [isAddMode, setIsAddMode] = useState(true);
	const [apiTokenHeader, setApiTokenHeader] = useState(false);
	const disableFormEdit =
		itemStatus === "Rejected" || itemStatus === "Approved";
	const [formStatus, setFormStatus] = useState(itemStatus);
	const [errorMessage, setErrorMessage] = useState(null);
	const validate = Yup.object().shape({
		workType: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		startTime: Yup.object().shape({
			hours: Yup.string().required("Required"),
		}),
		empComments: Yup.string()
			.required("Reason is required")
			.typeError("Invalid input")
			.max(500, "Max 600 characters allowed"),
	});

	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		if (id) {
			setIsAddMode(false);
			//Get Selected Data
			axios
				.get(`${OffsiteHours_API.GetOffsiteHoursById}/${id}`, {
					headers: header,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						const to12Hours = moment(
							data.startTime,
							"hh mm"
						).format("LT");

						const workDurationHours = data.workDuration.substring(
							0,
							data.workDuration.indexOf("Hrs")
						);
						const workDurationMins = data.workDuration.substring(
							data.workDuration.indexOf(":") + 1,
							data.workDuration.indexOf("Mins") - 1
						);

						setOffsiteRequestFormFields({
							startTime: {
								hours: to12Hours.substring(
									0,
									to12Hours.lastIndexOf(":")
								),
								minutes: to12Hours.substring(
									to12Hours.lastIndexOf(":") + 1,
									to12Hours.lastIndexOf(" ")
								),
								time:
									to12Hours.substring(
										to12Hours.lastIndexOf(" ") + 1
									) === "AM"
										? { value: 0, label: "AM" }
										: { value: 1, label: "PM" },
							},
							date: Date.parse(data.requestDate),
							workType: workTypeOptions.filter((x) => {
								if (x.value === data.workType) {
									return x;
								}
							})[0],
							workHours: {
								hours: workHoursOptions.filter((x) => {
									if (x.value == workDurationHours) {
										return x;
									}
								})[0],
								minutes: workMinutesOptions.filter((x) => {
									if (x.label === workDurationMins) {
										return x;
									}
								})[0],
							},
							empComments: data.employeeComments,
						});
					}
				});
		} else {
			//display default
			axios
				.get(`${OffsiteHours_API.GetWorkType}`, {
					headers: header,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						setWorkTypes(data.workTypes);
					}
				});
		}
		setApiTokenHeader(header);
	}, []);

	const handleChange = (temp, displayCode, e) => {
		if (displayCode === 1) {
			//dropdownMenu
			setOffsiteRequestFormFields({
				...offsiteRequestFormFields,
				["workType"]: temp,
			});
		} else if (displayCode === 2) {
			//datePicker
			setOffsiteRequestFormFields({
				...offsiteRequestFormFields,
				["date"]: temp,
			});
		} else {
			const { name, value } = temp.target;
			setOffsiteRequestFormFields({
				...offsiteRequestFormFields,
				[name]: value,
			});
		}
	};
	const handleStartTimeSelect = (event, displayCode) => {
		// handle StartTime
		if (displayCode === 1) {
			//startTime Hours
			setOffsiteRequestFormFields({
				...offsiteRequestFormFields,
				["startTime"]: {
					hours: event.target.value,
					minutes: offsiteRequestFormFields.startTime.minute,
					time: offsiteRequestFormFields.startTime.time,
				},
			});
		} else if (displayCode === 2) {
			//startTime Minutes
			setOffsiteRequestFormFields({
				...offsiteRequestFormFields,
				["startTime"]: {
					hours: offsiteRequestFormFields.startTime.hours,
					minutes: event.target.value,
					time: offsiteRequestFormFields.startTime.time,
				},
			});
		} else {
			//startTime AM/PM
			setOffsiteRequestFormFields({
				...offsiteRequestFormFields,
				["startTime"]: {
					hours: offsiteRequestFormFields.startTime.hours,
					minutes: offsiteRequestFormFields.startTime.minutes,
					time: event,
				},
			});
		}
	};
	const handleWorkSelect = (value, displayCode) => {
		//Work Hours DropDown
		if (displayCode === 1) {
			//work Hours
			setOffsiteRequestFormFields({
				...offsiteRequestFormFields,
				["workHours"]: {
					hours: value,
					minutes: offsiteRequestFormFields.workHours.minutes,
				},
			});
		} else {
			//work Minutes
			setOffsiteRequestFormFields({
				...offsiteRequestFormFields,
				["workHours"]: {
					hours: offsiteRequestFormFields.workHours.hours,
					minutes: value,
				},
			});
		}
	};

	const handleReset = () => {
		setOffsiteRequestFormFields({
			employeeName: "",
			startTime: {
				hours: "",
				minutes: "",
				time: { value: 0, label: "AM" },
			},
			date: offsiteRequestFormFields.date,
			workType: "",
			workHours: {
				hours: { value: 1, label: "01" },
				minutes: { value: 0, label: "00" },
			},
			empComments: "",
		});
	};

	const handleSubmit = () => {
		//should not submit if start Time is wrong
		if (parseInt(offsiteRequestFormFields.startTime.hours > 12)) {
			setErrorMessage("Start Time Hour should be between 0 to 12");
		} else {
			setErrorMessage("");

			if (isAddMode) {
				createOffsiteRequest();
			} else {
				updateOffsiteRequest();
			}
		}
	};
	const createOffsiteRequest = () => {
		const startTime =
			offsiteRequestFormFields.startTime.hours +
			":" +
			offsiteRequestFormFields.startTime.minutes +
			" " +
			offsiteRequestFormFields.startTime.time.label;

		const requestBody = {
			startTime: moment(startTime, ["h:mm A"]).format("HH:mm"),
			workType: offsiteRequestFormFields.workType.value,
			requestDate: offsiteRequestFormFields.date,
			workingHours: offsiteRequestFormFields.workHours.hours.value,
			workingMinutes: offsiteRequestFormFields.workHours.minutes.label,
			employeeComments: offsiteRequestFormFields.empComments,
		};

		axios
			.post(`${OffsiteHours_API.PostOffsiteRequest}`, requestBody, {
				headers: apiTokenHeader,
			})
			.then(({ status, message }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Offsite Work Hours Requested",
					});
					history.push(Routes.OffsiteWorkHours);
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};

	const updateOffsiteRequest = () => {
		if (parseInt(offsiteRequestFormFields.startTime.hours) > 12) {
			setErrorMessage("Start Time Hour should be between 0 to 12");
		} else {
			const startTime =
				offsiteRequestFormFields.startTime.hours +
				":" +
				offsiteRequestFormFields.startTime.minutes +
				" " +
				offsiteRequestFormFields.startTime.time.label;

			const requestBody = {
				startTime: moment(startTime, ["h:mm A"]).format("HH:mm"),
				workType: offsiteRequestFormFields.workType.value,
				requestDate: moment(offsiteRequestFormFields.date).format(
					APIDateFormat
				),
				workingHours: offsiteRequestFormFields.workHours.hours.value,
				workingMinutes:
					offsiteRequestFormFields.workHours.minutes.label,
				employeeComments: offsiteRequestFormFields.empComments,
			};
			axios
				.put(
					`${OffsiteHours_API.UpdateOffsiteWorkHours}/${id}`,
					requestBody,
					{
						headers: apiTokenHeader,
					}
				)
				.then(({ status, message }) => {
					if (status === 200) {
						setFormStatus("Updated");
						AlertPopups.successAlert.fire({
							text: "Offsite Work Request Updated",
						});
						history.push(Routes.OffsiteWorkHours);
					} else if (status === 400) {
						AlertPopups.ErrorAlert.fire({
							text: message,
						});
					}
				})
				.catch((error) => {
					if (error.response)
						AlertPopups.ErrorAlert.fire({
							text: error.response.data.message,
						});
				});
		}
	};

	const handleDelete = () => {
		AlertPopups.confirmBox
			.fire({
				text: "Delete Offsite Request?",
			})
			.then((result) => {
				if (result.value) {
					return axios
						.delete(
							`${OffsiteHours_API.DeleteOffsiteWorkHours}/${id}`,
							{
								headers: { Authorization: `Bearer ${token}` },
							}
						)
						.then(({ status, message }) => {
							if (status === 200) {
								AlertPopups.successAlert.fire({
									text: "Offsite Work Request Deleted",
								});
								history.push(Routes.OffsiteWorkHours);
							} else if (status === 400) {
								AlertPopups.ErrorAlert.fire({
									text: message,
								});
							}
						});
				}
			});
	};
	const openDatepicker = () => {
		const datepickerElement = datepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const getStartTimeInputClassName = (errors) => {
		if (errors.startTime) {
			return errors.startTime.hours
				? "startTimeInput formValueInput invalid"
				: "startTimeInput formValueInput";
		} else {
			return "startTimeInput formValueInput";
		}
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				userName = userDetails.name;
				return (
					<>
						<div className="container-fluid pl-3 pr-3">
							<FormStatus
								title="Offsite Work Request"
								formStatus={formStatus}
								className="create-request d-flex align-items-center"
								onClick={() => {
									history.push(Routes.OffsiteWorkHours);
								}}
								navigateBack={true}
							/>

							{/*Error message container*/}
							{errorMessage ? (
								<div className="errorMessageContainer errorMessage">
									<span className="errorIndicator">*</span>
									{errorMessage}
								</div>
							) : null}

							{/*Form*/}
							<Formik
								enableReinitialize={true}
								initialValues={offsiteRequestFormFields}
								validationSchema={validate}
								validateOnChange={true}
								onSubmit={() => {
									handleSubmit();
								}}
							>
								{({ errors, handleSubmit }) => (
									<form
										onSubmit={handleSubmit}
										className="my-4"
									>
										<div className="offsiteHoursForm">
											<div className="formInfoContainerHeader">
												<Label sm={12}>
													Offsite Work Details
												</Label>
											</div>
											<FormGroup
												row
												sm={12}
												className="my-1 formFieldsHeading col-form-label"
											>
												<Label sm={2}>
													Employee Name
												</Label>
												<div className="col-sm-4 mb-3 mb-lg-0 mb-md-0 formValueContainer textOverflow">
													<span
														sm={4}
														className="dataSpan"
													>
														{userName}
													</span>
												</div>
												<Label sm={2}>
													Work Date
												</Label>
												<div
													style={{
														fontWeight: "normal",
													}}
													className="col-sm-4 mb-3 mb-lg-0 mb-md-0 pl-0 pr-0 textOverflow"
												>
													<Col className="datepicker-wrapper pl-md-1">
														<DatePicker
															showYearDropdown
															showMonthDropdown
															dateFormatCalendar=" " //for title
															style={{
																fontSize:
																	"30px",
															}}
															className={`custom-container formValueInput ${
																id
																	? "disabledCalenderPicker border border-secondary"
																	: "custom-container"
															}`}
															autoComplete="off"
															selected={
																offsiteRequestFormFields.date
															}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	2,
																	event
																)
															}
															disabled={
																itemStatus !=
																"Draft"
															}
															maxDate={new Date()}
															dateFormat="dd/MM/yyyy"
															ref={datepickerRef}
														/>
														<FontAwesomeIcon
															icon={faCalendarAlt}
															className="calender-icon"
															color="keppel"
															onClick={() =>
																openDatepicker()
															}
														/>
													</Col>
												</div>
											</FormGroup>
											<FormGroup
												row
												sm={12}
												className="my-1 formFieldsHeading col-form-label"
											>
												<label className="formFieldsHeading my-1 col-4 col-sm-2 col-md-2 col-lg-2 col-form-label">
													Start Time{" "}
													<span className="required">
														*
													</span>
												</label>
												<div className="formInputContainer my-1 col-8 col-sm-4 col-md-4 col-lg-4">
													<Row className="pl-2 d-flex align-items-center">
														<Col className="p-0 px-1 col-5 col-sm-5 col-md-5 col-lg-3 ">
															<Input
																type="number"
																name="hours"
																min={0}
																max={12}
																placeholder="00"
																autoComplete="off"
																className={getStartTimeInputClassName(
																	errors
																)}
																value={
																	offsiteRequestFormFields
																		.startTime
																		.hours
																}
																onChange={(
																	event
																) => {
																	//limits to 2 digit
																	if (
																		event
																			.target
																			.value
																			.length ===
																		3
																	)
																		return false;
																	else
																		handleStartTimeSelect(
																			event,
																			1
																		);
																}}
																disabled={
																	disableFormEdit
																}
															/>
														</Col>
														<span className="colon">
															:
														</span>
														<Col className="p-0 px-1 col-5 col-sm-5 col-md-5 col-lg-3">
															<Input
																type="number"
																name="minutes"
																min={0}
																max={60}
																placeholder="00"
																autoComplete="off"
																className={
																	"startTimeInput formValueInput"
																}
																value={
																	offsiteRequestFormFields
																		.startTime
																		.minutes
																}
																onChange={(
																	event
																) => {
																	//limits to 2 digit
																	if (
																		event
																			.target
																			.value
																			.length ===
																		3
																	)
																		return false;
																	else
																		handleStartTimeSelect(
																			event,
																			2
																		);
																	handleStartTimeSelect(
																		event,
																		2
																	);
																}}
																disabled={
																	disableFormEdit
																}
															/>
														</Col>
														<Col className="pl-0 col-10 col-sm-11 col-md-10 col-lg-5">
															<CustomReactSelect
																options={
																	timeOptions
																}
																isDisabled={
																	disableFormEdit
																}
																value={
																	offsiteRequestFormFields
																		.startTime
																		.time !=
																	undefined
																		? offsiteRequestFormFields
																				.startTime
																				.time
																		: ""
																}
																className="timeSelectOptions"
																onChange={(
																	event
																) =>
																	handleStartTimeSelect(
																		event,
																		3
																	)
																}
															/>
														</Col>
													</Row>
												</div>
												<Label
													sm={2}
													className="my-1 formFieldsHeading col-form-label"
												>
													Work Hours
												</Label>
												<Col className="pl-md-0 m-0">
													<CustomReactSelect
														options={
															workHoursOptions
														}
														className="workHoursInput"
														value={
															offsiteRequestFormFields
																.workHours.hours
														}
														onChange={(value) =>
															handleWorkSelect(
																value,
																1
															)
														}
														isDisabled={
															disableFormEdit
														}
													/>
												</Col>
												<Col className="pl-0 m-0">
													<CustomReactSelect
														options={
															workMinutesOptions
														}
														className="workHoursInput"
														value={
															offsiteRequestFormFields
																.workHours
																.minutes
														}
														onChange={(value) =>
															handleWorkSelect(
																value,
																2
															)
														}
														isDisabled={
															disableFormEdit
														}
													/>
												</Col>
											</FormGroup>
											<FormGroup
												row
												className="my-1 formFieldsHeading col-form-label"
											>
												<Label sm={2}>
													Work Type
													<span className="required">
														*
													</span>
												</Label>
												<div
													className="col-sm-4 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow"
													style={{
														fontWeight: "normal",
													}}
												>
													<span
														sm={4}
														className="dataSpan "
													>
														<CustomReactSelect
															name="workType"
															className={`${
																errors.workType
																	? "h-auto invalid"
																	: "h-auto"
															}`}
															isDisabled={
																disableFormEdit
															}
															options={
																workTypes
																	? workTypes.sort(
																			(
																				a,
																				b
																			) =>
																				a.label.localeCompare(
																					b.label
																				)
																	  )
																	: workTypeOptions.sort(
																			(
																				a,
																				b
																			) =>
																				a.label.localeCompare(
																					b.label
																				)
																	  )
															}
															value={
																offsiteRequestFormFields.workType
															}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	1,
																	event
																)
															}
														/>
													</span>
												</div>
												<Label sm={2}>
													Reason{" "}
													<span className="required">
														*
													</span>
												</Label>
												<div className="col-sm-4 mb-3 pr-4 pl-md-0 mb-lg-0 mb-md-0 mt-2 textOverflow">
													{" "}
													<Input
														type="textarea"
														name="empComments"
														className={`supDesciptionBox ${
															errors.empComments
																? "h-auto invalid"
																: "h-auto"
														}`}
														onChange={(
															value,
															event
														) =>
															handleChange(
																value,
																4,
																event
															)
														}
														value={
															offsiteRequestFormFields.empComments
														}
														maxLength="400"
														disabled={
															disableFormEdit
														}
													/>
												</div>
											</FormGroup>
										</div>

										{/* Buttons Container*/}
										<div className="btns">
											{id ? (
												itemStatus === "Pending" ? (
													<>
														<Button
															className="delete-btn leftBtn"
															onClick={
																handleDelete
															}
														>
															Delete
														</Button>
														<Button
															className="submit-btn leftBtn"
															onClick={
																handleSubmit
															}
														>
															Update
														</Button>
														<Button
															className="reset-btn "
															onClick={
																handleReset
															}
														>
															Reset
														</Button>
													</>
												) : null
											) : (
												<Button
													type="submit"
													className="submit-btn"
												>
													Submit
												</Button>
											)}
										</div>
									</form>
								)}
							</Formik>
						</div>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default OffsiteHoursRequestForm;
